/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AddInsurance/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function AddInsurance({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/AddAction/AddInsurance"
  
}) {
let paymentPlanInsurancesValueData = fromData.useDataFormat({ viewPath,
context: 'payment_plan',
path: 'insurances',
format: fromFormat.listLength,
})
let constantData = 2
let aggregateData = fromAggregate.equals(paymentPlanInsurancesValueData, constantData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 width="100%"
 type="ghost"
 onClick={onClick}
 data="payment_plan.insurances"
 format="/Data/format.js listLength"
 data={2}
 aggregate="/Data/aggregate.js equals"
 disabled={aggregateData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Insurance"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}